import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { NotFoundMessage } from '@peracto/peracto-ui'

import styled from 'styled-components'

export const NoMatchContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4rem;
    padding-bottom: 4rem;
    height: 100vh;

    p {
        font-size: 1.1rem;
    }
`

const NoMatchRoute = () => {
    return (
        <Switch>
            <Route render={() => <NotFoundMessage />} />
        </Switch>
    )
}

export default NoMatchRoute
